<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Keyword" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">委托主体:</div>
                <el-input v-model="conditionData.Wtzt" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">报案号:</div>
                <el-input v-model="conditionData.CaseNo" size="small" placeholder="请输入"></el-input>
            </div>
            
            
            <div class="item">
                <div class="label">案件类型:</div>
                <el-select v-model="conditionData.CaseType" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany">
                    <el-option
                    v-for="item in caseTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <div class="item">
                <div class="label">案件状态:</div>
                <el-select v-model="conditionData.PiccHumanStatus" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany" multiple style="width:540px">
                    <el-option
                    v-for="item in PiccHumanTaskStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <div class="item">
                <div class="label">地区:</div>
                <el-cascader
                    size="small"
                    :options="options"
                    v-model="crimeCityCode"
                    @change="handleRegionChange">
                </el-cascader>
            </div>
            


            <div class="item">
                <div class="label">时间:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.EndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            

            <div class="item">
                <div class="label">标的车牌或电话:</div>
                <el-input v-model="conditionData.CarNoTel" size="small" placeholder="请输入标的车牌或电话"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
                <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel()">导出数据</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新增案件</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="600"
                style="width: 100%">
                <el-table-column
                prop="wtzt"
                label="委托主体"
                align="center"
                width="280px"
                >
                </el-table-column>
                <el-table-column
                prop="caseNo"
                label="报案号"
                align="center"
                width="220px"
                >
                </el-table-column>
                <el-table-column
                prop="caseType"
                label="案件类型"
                align="center"
                width="80px"
                >
                <template slot-scope="scope">
                        {{scope.row.caseType==0?"首勘":"全流程"}}
                </template>
                </el-table-column>
                
                <el-table-column
                prop="piccHumanStatus"
                label="案件状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                        {{scope.row.piccHumanStatus==0?"新案件":""}}
                        {{scope.row.piccHumanStatus==10?"已指派人伤岗":""}}
                        {{scope.row.piccHumanStatus==20?"已指派查勘中":""}}
                        {{scope.row.piccHumanStatus==25?"指派查勘完成":""}}
                        {{scope.row.piccHumanStatus==30?"查勘待审核":""}}
                        {{scope.row.piccHumanStatus==40?"已完成":""}}
                        {{scope.row.piccHumanStatus==-1?"取消委托":""}}
                        {{scope.row.piccHumanStatus==-2?"未决案件":""}}
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="humanStatus"
                label="任务状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    {{scope.row.humansStatus==0?"新任务":""}}
                    {{scope.row.humansStatus==10?"查勘中":""}}
                    {{scope.row.humansStatus==20?"查勘审核":""}}
                    {{scope.row.humansStatus==30?"查勘退回":""}}
                    {{scope.row.humansStatus==40?"人伤跟踪":""}}
                    {{scope.row.humansStatus==60?"方案制作中":""}}
                    {{scope.row.humansStatus==70?"方案审核":""}}
                    {{scope.row.humansStatus==72?"审核退回":""}}
                    {{scope.row.humansStatus==75?"协议签署中":""}}
                    {{scope.row.humansStatus==80?"任务完成":""}}
                </template>
                </el-table-column> -->
                
                <el-table-column
                prop="province"
                label="省份"
                align="center"
                width="120px"
                >
                
                </el-table-column>

                <el-table-column
                prop="city"
                label="城市"
                align="center"
                width="120px"
                >
                
                </el-table-column>
                
                <el-table-column
                prop="address"
                label="案发地点"
                align="center"
                width="300px"
                >
                
                </el-table-column>

                <el-table-column
                prop="contacts"
                label="联系人"
                align="center"
                width="120px"
                >
                </el-table-column>
                <el-table-column
                prop="contactsPhone"
                label="联系人电话"
                align="center"
                width="120px"
                >
                </el-table-column>
                <el-table-column
                prop="contactsAddress"
                label="联系人地址"
                align="center"
                width="200px"
                >
                </el-table-column>

                <el-table-column
                prop="piccStatus"
                label="主案件状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    {{scope.row.piccStatus==1?"案件未完成":""}}
                    {{scope.row.piccStatus==2?"已核损待结案":""}}
                    {{scope.row.piccStatus==3?"已结案":""}}
                </template>
                </el-table-column>
                <el-table-column
                prop="financialStatus"
                label="财务状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    {{scope.row.financialStatus==0?"无":""}}
                    {{scope.row.financialStatus==1?"已开票未回款":""}}
                    {{scope.row.financialStatus==2?"已开票部分回款":""}}
                    {{scope.row.financialStatus==3?"回款完成":""}}
                    {{scope.row.financialStatus==4?"已回款未开票":""}}
                    {{scope.row.financialStatus==5?"其他":""}}
                </template>
                </el-table-column>
                
                <el-table-column
                prop="targetLand"
                label="标地责任"
                align="center"
                width="80px"
                >
                
                </el-table-column>

                <el-table-column
                prop="zenRenBiLi"
                label="责任比例"
                align="center"
                width="80px"
                >
                
                </el-table-column>

                <el-table-column
                prop="fee"
                label="公估费"
                align="center"
                width="80px"
                >
                
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="委托时间"
                align="center"
                width="160px"
                >
                
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="detail(scope.row)">查看详情</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>



      
        
    </div>
</template>
<script>
import api from '../../../api/main'
import {CaseTypeList , PiccHumanStatusList , TaskStatusList , PiccHumanTaskStatusList} from '../../../assets/selectList/index'
import { regionDataPlus , provinceAndCityData , CodeToText } from "element-china-area-data";

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            TaskStatusList:TaskStatusList,
            PiccHumanStatusList:PiccHumanStatusList,
            PiccHumanTaskStatusList:PiccHumanTaskStatusList,
            title:'',
            tableData:[],
            totalCount:0,
            conditionData:{
                Keyword:'',
                PiccHumanStatus:[],
                // PiccHumanStatus:[10,20,30,40,-2,-1],
                Wtzt:'',
                CaseNo:'',
                CaseType:null,
                Province: '',
                City:'',
                StartTime:'',
                EndTime:'',
                dispatchId:null,
                CarNoTel:'',
                page:1,
                pageSize:10,
            },
            dispatchId:null,
            companyList:[],

            caseTypeList:CaseTypeList,
            options:provinceAndCityData,
            crimeCityCode:[],


            isHQ:'',
            dispatchList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'本人',
                    value:localStorage.getItem('id'),
                }
            ],
        }
    },
    created(){
        // this.isHQ = localStorage.getItem('isHQ');
        // if(this.isHQ=='1'){
        // }else{
        //     this.conditionData.MechanismId = localStorage.getItem('mechanismId');
        // }


        if(sessionStorage.getItem('conditionDataCaseTaskAll')){
            this.conditionData = JSON.parse(sessionStorage.getItem('conditionDataCaseTaskAll'));
        }
        this.loadingData();
        sessionStorage.removeItem('conditionDataCaseTaskAll');
        
    },
    mounted(){
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            // this.conditionData.dispatchId = null;
            // if(this.dispatchId){
            //     this.conditionData.dispatchId = this.dispatchId
            // }else{
            //     delete this.conditionData.dispatchId
            // }


            // let res  = await api.queryDcDoubtTask(this.conditionData);
            this.conditionData.dispatchId = null;
            let res  = await api.piccHumanTaskQueryPager(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.dispatchId=null;
            this.crimeCityCode = [];
            this.conditionData = {
                Keyword:'',
                // PiccHumanStatus:[10,20,30,40,-2,-1],
                PiccHumanStatus:[],
                Wtzt:'',
                CaseNo:'',
                CaseType:null,
                Province: '',
                City:'',
                StartTime:'',
                EndTime:'',
                dispatchId:null,
                CarNoTel:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
       

        handleRegionChange(codeArray){
            if(codeArray[0]){
                this.conditionData.Province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.conditionData.City = CodeToText[codeArray[1]]
            }
           
        },
        detail(row){
            sessionStorage.setItem('conditionDataCaseTaskAll',JSON.stringify(this.conditionData));
            this.$router.push({
                name:'caseTaskManageDetail',
                query:{
                    id:row.id,
                    taskId:row.piccHumanTaskId
                }
            })
        },
        async downloadExcel(){
            console.log(this.conditionData)
            this.conditionData.dispatchId = localStorage.getItem('id');
            this.conditionData.userName = localStorage.getItem('name');
            let res = await api.exportExcel({
                "type" :2 ,
                "condition":this.conditionData
            },'任务列表');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .tb-red{
            color:red;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
